import cx from 'classnames';
import React from 'react';
import { Icon, IconColor, IconSize } from '../../../../icon';
import styles from './icon-column.module.scss';
export const IconButtonColumn = React.memo(({ data, colDef }) => {
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'icon'];
    const iconButtonColumn = {
        ...fieldValues,
    };
    const onClick = (e) => {
        if (!iconButtonColumn.disabled) {
            iconButtonColumn.onClick(e, data);
        }
    };
    return (React.createElement("div", { className: styles.iconColumnContainer, "data-tooltip-content": iconButtonColumn.toolTip, "aria-label": iconButtonColumn.toolTip, "data-testid": "icon-button-column-testid" },
        React.createElement("button", { disabled: iconButtonColumn.disabled, type: "button", onClick: (event) => onClick(event), className: cx(styles.iconButton, {
                [styles.iconButtonDisable]: iconButtonColumn.disabled,
            }), "data-testid": "icon-button-column-button-testid" },
            React.createElement(Icon, { className: cx(styles.icon, {
                    [`${iconButtonColumn.icon.className}`]: iconButtonColumn
                        .icon.className,
                }), id: iconButtonColumn.icon.id, color: iconButtonColumn.icon.color || IconColor.TEXT_COLOR, size: iconButtonColumn.icon.size || IconSize.MEDIUM }))));
});
//# sourceMappingURL=icon-button-column.js.map